import React from "react";
import { ModalAlert } from "../../common/dialog/modalAlert";
import Row from "../../common/layout/row";
import Button from "../../common/button/button";
import AlertIcon from "../../common/alertIcon/alertIcon";
import DateFormat from "../../common/dateFormat/DateFormat";
import Td from "../../common/table/td";
import NewTr from "../../common/table/newTr";
import TBody from "../../common/table/tBody";
import THead from "../../common/table/tHead";
import Table from "../../common/table/table";
import ContentCardBody from "../../common/template/contentCardBody";
import Grid from "../../common/layout/grid";

export function ModalFaturasVencidas(props) {
    if (!props.visible) return null;

    return (
        <ModalAlert titulo="Faturas Vencidas de Meses Anteriores" handleClose={props.handleClose}>
            <ContentCardBody style={{ marginBlock: 20 }}>
                <div className="custom-scroll" style={{ borderRadius: "0.3rem", overflow: "hidden", border: "1px solid #DDD" }}>
                    <Table responsive>
                        <THead></THead>
                        <TBody>
                            {props.listaFaturasVencidas.map((item, iTr) => (
                                <NewTr noButtons backgroundColorTr={iTr % 2 == 0 ? "#DDD" : "#EEE"}>
                                    <Td>{item.nome_unidade_consumidora}</Td>
                                    <Td>
                                        <ul
                                            style={{
                                                margin: 0,
                                                display: "flex",
                                                flexDirection: "column",
                                                justifyContent: "center",
                                                listStyle: "none",
                                            }}
                                        >
                                            {item.faturas_vencidas.map((fatura, i, list) => (
                                                <li>
                                                    <div
                                                        className="d-flex align-items-center my-1"
                                                        style={{
                                                            borderBottom: i == list.length - 1 ? null : "1px solid #999",
                                                            paddingBottom: i == list.length - 1 ? null : 5,
                                                        }}
                                                    >
                                                        <AlertIcon animationClass={"alerta-triangulo-visualizado pr-3 pb-1"} title="" event={() => {}} />
                                                        <div style={{ marginBottom: 3 }}>
                                                            Fatura de {fatura.mes + "/" + fatura.ano} - vencida desde {DateFormat.formatarDataSqlParaTela(fatura.data_vencimento)}
                                                        </div>
                                                    </div>
                                                </li>
                                            ))}
                                        </ul>
                                    </Td>
                                </NewTr>
                            ))}
                        </TBody>
                    </Table>
                    <Row alignCenter style={{ paddingRight: 5 }}>
                        <Grid cols="12 12 4 4" style={{ display: "flex", justifyContent: "center" }}>
                            <Button
                                text={<span style={{ fontSize: "clamp(0.6rem, 2vw, 0.8rem)", whiteSpace: "nowrap" }}>Verificar</span>}
                                title="Verificar"
                                type={"primary"}
                                icon={"fa fa-search"}
                                event={props.handleVerificarFaturas}
                            />
                        </Grid>
                    </Row>
                </div>
            </ContentCardBody>
        </ModalAlert>
    );
}
